import { useEffect, useState } from "react";
import api from "../lib/api";
import { getCachedSiteContent } from "../lib/useSiteContent";
import SeoHead from "./SeoHead";

/**
 * SEO helper for static public pages whose meta is managed entirely through
 * Site Content (admin → /admin/site-content → SEO group).
 *
 * Pass a `pageKey` (e.g. "articles", "sentiment", "insights", "trackers",
 * "privacy", "terms") and the component will look up
 *   site_content.seo_{pageKey}_title
 *   site_content.seo_{pageKey}_description
 * with optional `defaultTitle` / `defaultDescription` for first-render fallback.
 *
 * `path` is the URL path used to build the canonical link (eg. "/articles").
 */
export default function SeoPageHead({ pageKey, path, defaultTitle, defaultDescription, structuredData }) {
  const [cms, setCms] = useState(getCachedSiteContent);
  useEffect(() => {
    api.get("/site-content").then((r) => setCms(r.data || {})).catch(() => {});
  }, []);
  const title = cms[`seo_${pageKey}_title`] || defaultTitle;
  const description = cms[`seo_${pageKey}_description`] || defaultDescription;
  // Build canonical from admin-configured base when present; otherwise fall back
  // to the current window origin + page path. This guarantees every public page
  // emits a <link rel=canonical> even when seo_canonical_base hasn't been set.
  const base = cms.seo_canonical_base || (typeof window !== "undefined" ? window.location.origin : "");
  const canonical = base ? `${base.replace(/\/$/, "")}${path || (typeof window !== "undefined" ? window.location.pathname : "")}` : undefined;
  const image = cms.seo_default_image_url || undefined;
  return (
    <SeoHead
      title={title}
      description={description}
      canonical={canonical}
      image={image}
      structuredData={structuredData}
    />
  );
}
